import * as R from 'ramda'
import toast from 'libs/toast'

const validMimeTypes = [
  'text/plain',
  'text/x-csv',
  'application/vnd.ms-excel',
  'application/csv',
  'application/x-csv',
  'text/csv',
  'text/comma-separated-values',
  'text/x-comma-separated-values',
  'text/tab-separated-values',
  'text/xlsx',
]
export const checkFileType = (file) => {
  const promise = new Promise((resolve) => {
    const isValid = R.contains(file.type, validMimeTypes) || file.name.includes('.csv')
    if (isValid) {
      resolve({ file })
    } else {
      toast.error('Uh oh. Please correct the following file type')
      resolve({ warningMessage: 'type error' })
    }
  })
  return promise
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ImportCustomerModal/utils/checkfilscsv.js